/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of Merative                         */
/*                                                                   */
/* (C) Copyright Merative Corp. 2025                                 */
/*                                                                   */
/* ***************************************************************** */
import {get} from "../../../../../../utils";
import {generateNutrientData} from "../utils/generateNutrientData";
import {Fragment, useRef} from "react";

export const DataTableContainer =  ({data="", docIds=[], displayFormat})  => {
  const tableRef = useRef(null);

  console.log("DataTableContainer children", data);
  console.log("docIds", docIds);
  const results = get(data, 'results');
  console.log("results", results);

  if (!docIds.length || !results ||get(results, docIds[0].toString()) === undefined) {
      console.log("docIds array is empty. Cannot fetch formula.");
      return <div>No data available</div>;
  }

  const formula = get(results, docIds[0].toString());
  console.log("formula", formula)
    const measurements_content = formula?.docs?.[0]?.content || [];
  const measurements = measurements_content[0]?.value || {};
  const perLiter = measurements.perLiter ? (<th>Per Liter</th>) : null;
  const per100Cal = measurements.per100Cal ? (<th>Per 100 cal</th>) : null;
  const colSpan= perLiter&&per100Cal?"2":"1"
  const formula_table_data =
      <div className="nutrient-details-table-content">
          <div className="nutrientResultsDiv">
            <table ref={tableRef} className="NFResultsTable">
              <thead>
              <tr>
                  <th rowSpan="2"><strong>Nutrient</strong></th>
                  {docIds.map((docId) => (
                      <Fragment key={docId}>
                          <th colSpan={colSpan}>
                              <strong>
                                {get(data.results, docId.toString())?.docs?.[0]?.title}
                              </strong>
                          </th>
                      </Fragment>
                  ))}
              </tr>
              <tr>
                  {docIds.map((docId) => (
                      <Fragment className="setlowzindex"  key={docId}>
                          {per100Cal ? <th className="setlowzindex" key={`${docId}-per100Cal`}>Per 100 cal</th>:null}
                          {perLiter ?<th key={`${docId}-perLiter`}>Per Liter</th>:null}
                      </Fragment>
                  ))}
              </tr>
              </thead>
              <tbody>
              {
                  (() => {
                      const {row_label_data, row_data} = generateNutrientData(data,docIds);

                    const perLiterContent = (perLiter) => perLiter.trim() ? perLiter : "";
                    const per100CalContent = (per100Cal) =>  per100Cal.trim() ? per100Cal : "";
                    return row_label_data.map(([isSubtopic, label, sectionKey]) => (
                          <tr key={sectionKey}>
                              <td dangerouslySetInnerHTML={{__html: label}}></td>
                              {row_data[sectionKey].map(([perLiter, per100Cal]) => (
                                  < >
                                    {({
                                      per100Cal: <td>{per100CalContent(per100Cal)}</td>,
                                      perLiter: <td>{perLiterContent(perLiter)}</td>,
                                      both: (
                                          <>
                                            <td>{per100CalContent(per100Cal)}</td>
                                            <td>{perLiterContent(perLiter)}</td>

                                          </>
                                      )
                                    })[displayFormat] || null}
                                  </>
                              ))}
                          </tr>
                      ));
                  })()
              }
              </tbody>
            </table>
          </div>
      </div>

    console.log("docId", docIds)

    console.log(formula)
    if (!formula) {
        return <div>No data available</div>;
    }
    return (
        <div>
            {formula_table_data}
        </div>
    );

}

